export class PageConstant {
    public static ITEM_PER_PAGE = 50;
    public static ITEM_PER_PAGE_OPTIONS = [20, 50, 100];
}


export class DefaultPaginationConstant {
    public static ALL_ITEMS = 10000;
}